<div class="project-building-data">
<acabim-datatable #dataTable
                  [dataSources]="dataSources"
                  hasDetailView="true">
</acabim-datatable>
</div>
